export const getUniqueArchiveParams = (blockId: string) => {
  // Create a hash to generate a shorter, consistent ID

  return {
    filterId: `f-${blockId}`,
    paginationId: `p-${blockId}`,
    sortingId: `s-${blockId}`,
  }
}
